import { useMemo } from 'react';

const Starfield = () => {
  const stars = useMemo(() =>
    Array.from({ length: 120 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 2 + 0.5,
      delay: Math.random() * 4,
      duration: Math.random() * 3 + 2,
    })), []);

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0" data-testid="starfield">
      {stars.map(s => (
        <div
          key={s.id}
          className="absolute rounded-full bg-white star-twinkle"
          style={{
            left: `${s.x}%`,
            top: `${s.y}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
          }}
        />
      ))}
    </div>
  );
};

export default Starfield;
